import { useFormContext } from "react-hook-form";
import Divider from "@mui/material/Divider";
import { Text } from "$components";
import CField from "$forms/CField";
import { useStyles } from "../../styles/DeliveryPicker.styles";
import BataillogDatePicker from "$components/BataillogDatePicker/BataillogDatePicker";
import { toLocalDateString } from "$utils/utils";

export default function DateIntervention() {
  const classes = useStyles();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={`${classes.contentStep3} show`}>
      <div className={classes.contentStep3Title}>
        <Text className={classes.subtitle}>
          Date prévue d&apos;intervention
        </Text>
      </div>
      <div
        className={classes.contentStep3Content}
        style={{
          flex: 1,
          display: "flex",
        }}
      >
        <CField
          control={control}
          label="Date prévue d'intervention"
          name="scheduledInterventionDate"
          error={errors.scheduledInterventionDate}
          variant="outlined"
          style={{
            paddingTop: "15px",
            maxWidth: 250,
          }}
          rules={{
            pattern: {
              value:
                "^(0?[1-9]|[12][0-9]|3[01])[\\/\\-](0?[1-9]|1[012])[\\/\\-](2\\d{3})$",
              message: "Veuillez entrer une date valide",
            },
          }}
        >
          {(props: any) => (
            <BataillogDatePicker
              selectedDate={props.value ? new Date(props.value) : undefined}
              onDateChange={(d) =>
                props.onChange(d instanceof Date ? toLocalDateString(d) : null)
              }
              label={props.label}
              error={props.error}
              variant={props.variant}
              displayCalendarIcon
              style={{
                ...props.style,
                justifyContent: "center",
                maxWidth: 240,
                paddingRight: 20,
                width: "100%",
              }}
            />
          )}
        </CField>
      </div>
      <Divider className={classes.divider} />
    </div>
  );
}
